module.exports = __webpack_public_path__ + "static/media/CockroachLabs.86766e58.png";